import { useFormik } from 'formik'
import React from 'react'
import { Link } from 'react-router-dom'
import isEmail from 'validator/lib/isEmail'
import * as Yup from 'yup'
import { LoadingButton } from '../../../../../components/LoadingButton/LoadingButton'
import { ROUTES } from '../../../../../constants/routes'
import translations from '../../../../../translations/en.json'

interface IProps {
  onSubmit: (values: { email: string }) => Promise<void>
}

export const ForgotPasswordForm = (props: IProps) => {
  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldError,
    isSubmitting,
  } = useFormik<{ email: string }>({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .required((translations as any)['error.email_required'])
        .test('email', (translations as any)['error.email_invalid'], (val) => isEmail(val || '')),
    }),
    onSubmit: async (value, { setSubmitting }) => {
      try {
        await props.onSubmit(value)
      } catch (e: any) {
        if (e.param) {
          setFieldError(e.param, e.message)
        } else if (e.message) {
          setFieldError('email', e.message)
        }
      }
      setSubmitting(false)
    },
  })
  return (
    <form onSubmit={handleSubmit}>
      <h4 className="mb-4">Forgot your password?</h4>
      <p className="mb-4">
        Enter your email address below and we'll send you instructions to reset your password.
      </p>
      <div className="mb-3">
        <label>Your email address</label>
        <input
          id="email"
          name="email"
          autoComplete="email"
          className={'form-control' + (touched?.email && !!errors.email ? ' is-invalid' : '')}
          type="email"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
          autoFocus
        />
        <div className="invalid-feedback d-block">
          {touched?.email && !!errors?.email ? errors?.email : '\u00A0'}
        </div>
      </div>
      <div className="mb-3 mt-4">
        <LoadingButton type="submit" className="btn btn-primary btn-block" loading={isSubmitting}>
          Reset Password
        </LoadingButton>
        <Link to={ROUTES.LOGIN} className="d-block my-3">
          Never mind, go back
        </Link>
      </div>
    </form>
  )
}
